import { VisibilityState } from '@tanstack/react-table';
import { influencer } from '@round/api';
import { ExplorePlatform, getConnectedPlatforms } from '../../helpers';
import { CreatorProfileEmbeds } from '../CreatorProfileEmbeds/CreatorProfileEmbeds';
import { CreatorDetailsPanel } from '../CreatorDetailsPanel/CreatorDetailsPanel';
import styles from './ExpandedCreatorContent.module.css';

type Props = {
    creator: influencer.CreatorSearchResult;
    /** The platform the row's Platform column is on, which the panel's stats follow too. */
    selectedPlatform: ExplorePlatform;
    onPlatformSelect: (platform: ExplorePlatform) => void;
    columnVisibility: VisibilityState;
};

/** What a creator's row expands into: their profile embed, and a panel of the row's stats beside it. */
export const ExpandedCreatorContent = ({ creator, selectedPlatform, onPlatformSelect, columnVisibility }: Props) => {
    const connectedPlatforms = getConnectedPlatforms(creator);
    // The row can sit on a platform the creator has no account on, which leaves no profile to embed
    // for it, so the embed falls back to one they do have, and the panel's stats follow the embed.
    const platform = connectedPlatforms.includes(selectedPlatform) ? selectedPlatform : connectedPlatforms[0];

    return (
        <div className={styles.container}>
            {platform && <CreatorProfileEmbeds creator={creator} platform={platform} />}
            <CreatorDetailsPanel
                creator={creator}
                platform={platform ?? selectedPlatform}
                switchablePlatforms={connectedPlatforms.length > 1 ? connectedPlatforms : undefined}
                onPlatformSelect={onPlatformSelect}
                columnVisibility={columnVisibility}
            />
        </div>
    );
};
